module.exports = __webpack_public_path__ + "img/Tier 1 Alternative 4.00dd45d0.jpg";